/**
 * Direction of the "tick".
 * tag: 274
 * @readonly
 * @enum {string} (char)
 */
export enum TickDirection {
  /** Plus Tick */
  PlusTick = '0',
  /** Zero-Plus Tick */
  ZeroPlusTick = '1',
  /** Minus Tick */
  MinusTick = '2',
  /** Zero-Minus Tick */
  ZeroMinusTick = '3',
}
